// GORAMI Premium Theme JS

document.addEventListener('DOMContentLoaded', () => {
  // Initialization logic here
  console.log('GORAMI Theme Loaded');

  // Premium Scroll Animations
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Select elements to animate
  const animatedElements = document.querySelectorAll(`
    .h2, 
    .subtitle, 
    .collection-card, 
    .about-story__text-block, 
    .about-story__image-block, 
    .philosophy-item, 
    .collection-overview,
    .brand-values__item,
    .instagram-gallery__grid img,
    .product-card
  `);

  animatedElements.forEach(el => {
    el.classList.add('gs-reveal');
    observer.observe(el);
  });
});
